export enum GranularityEnum {
  GLIX = 'glix',
  ONE_MINUTE = '1m',
  TWO_MINUTES = '2m',
  FIVE_MINUTES = '5m',
  TEN_MINUTES = '10m',
  FIFTEEN_MINUTES = '15m',
}